
import { defineComponent } from "vue";
import Challenge from "@/components/account/Challenge.vue";

export default defineComponent({
  name: "ChallengeView",
  components: {
    Challenge,
  },
});
